import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import { getEmployeesOnInvoice } from "../../../../redux/invoice/invoiceState";
import EmployeeProfile from "components/card/EmployeeProfile";
import avatar from "assets/img/avatars/user.png";
import { NumberFormatter } from "../../../../utils/index";

const EmployeeCostServiceFeeTable = ({invoiceRecord, recordList, doSearch, getEmployeeCostFees}) => {

  	const columns = [
	    {
	        title: `Employee`,
	        dataIndex: 'inv_number',
	        key: 'inv_number',
	        width: '20%', 	        
	        render:(_, record) => (
				<EmployeeProfile
					avatar={avatar}
					record={record}
				/>
			),
	    },
		{
	        title: <div className="text-right">Monthly Salary</div>,
	        dataIndex: 'monthly_salary',
	        key: 'monthly_salary',
	        width: '15%', 	        
	        render:(monthly_salary) => <div className="text-right">{NumberFormatter(monthly_salary)}</div> 
	    },
	    {
	        title: <div className="text-right">Statutory Benefits</div>,
	        dataIndex: 'total_statutory',
	        key: 'total_statutory',
	        width: '15%',
			render:(total_statutory) => <div className="text-right">{NumberFormatter(total_statutory)}</div> 
	    },
		{
	        title: <div className="text-right">Employee Cost (AUD)</div>,
	        dataIndex: 'employeeCost',
	        key: 'employeeCost',
	        width: '15%',
			render:(employeeCost) => <div className="text-right">{NumberFormatter(employeeCost)}</div> 
	    },
		{
	        title: <div className="text-right">Service Fee (AUD)</div>,
	        dataIndex: 'serviceFee',
	        key: 'serviceFee',
	        width: '12%',
			render:(serviceFee) => <div className="text-right">{NumberFormatter(serviceFee)}</div> 
	    },
    ];
	
	useEffect(() => {
		if(invoiceRecord?.inv_id){
			getEmployeeCostFees({recordId: invoiceRecord?.inv_id});
		}
	}, [getEmployeeCostFees, invoiceRecord]);

  	return ( <>
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
					pagination={false}
	        	/>
	      	</div>
	    </Card>
	</>
  );
};

const mapStateToProps = (state) => ({
	invoiceRecord: state.invoice.invoiceDetails?.data,
	recordList: state.invoice.employeesOnInvoiceCost?.items,
  	requesting: state.invoice.employeesOnInvoiceCost?.requesting,
  	error: state.invoice.employeesOnInvoiceCost?.error,
});

const mapDispatchToProps = (dispatch) => ({
  getEmployeeCostFees: (id) => dispatch(getEmployeesOnInvoice(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCostServiceFeeTable);
